export const Colors = {
  primaryColor: '#29304D',
  secondaryColor: '#3c68c3',
  white: '#fff',
  black: '#000'
}
